<article
  class="now-decorative-card now-decorative-card-default d-flex flex-column align-items-center gap-2"
>
  <img
    class="empty-state"
    ngSrc="assets/images/undraw_searching.svg"
    height="128"
    width="120"
    alt=""
  />
  <h2 class="h3 mt-3 text-center" role="alert">Keine Ergebnisse für die Suche</h2>
  <div class="now-body-large">
    <ul class="now-list now-list-requirements">
      <li>Sucheingaben überprüfen</li>
      <li>Gesetzte Filter überprüfen</li>
      <li>bei Ortseingabe Umkreis anpassen</li>
    </ul>
  </div>
  <p class="text-center">
    Es kann immer vorkommen, dass aktuell keine betreffenden Angebote in der Datenbank vorliegen.
  </p>
</article>
